export const metaJourneys = {
  meta: {
    stages: [
      { minPct: 0,   maxPct: 0,        message: 'todo sueño empieza en cero. este es tu primer paso.' },
      { minPct: 1,   maxPct: 24,       message: 'ya empezaste — y eso es más de lo que hace la mayoría.' },
      { minPct: 25,  maxPct: 49,       message: 'un cuarto del camino. la constancia es silenciosa pero poderosa.' },
      { minPct: 50,  maxPct: 74,       message: 'estás a la mitad. el sueño ya no se ve tan lejos.' },
      { minPct: 75,  maxPct: 99,       message: 'casi. cada peso ahora tiene nombre propio.' },
      { minPct: 100, maxPct: Infinity, message: 'lo lograste. este sueño ya tiene dirección.' },
    ],
  },
  viaje: {
    stages: [
      { minPct: 0,   maxPct: 0,        message: 'el primer aporte es el boleto de salida.' },
      { minPct: 1,   maxPct: 24,       message: 'el viaje empieza a tomar forma. sigue imaginando.' },
      { minPct: 25,  maxPct: 49,       message: 'ya ahorras en serio para este viaje. tu yo futuro te lo va a agradecer.' },
      { minPct: 50,  maxPct: 74,       message: 'mitad del camino — el destino se acerca. ¿ya tienes las fechas?' },
      { minPct: 75,  maxPct: 99,       message: 'casi listo para partir. unos últimos aportes y es tuyo.' },
      { minPct: 100, maxPct: Infinity, message: 'el presupuesto está completo. ahora solo falta empacar.' },
    ],
  },
  proyecto: {
    stages: [
      { minPct: 0,   maxPct: 0,        message: 'los grandes proyectos nacen de una idea y un primer peso.' },
      { minPct: 1,   maxPct: 24,       message: 'el proyecto existe. ahora le das sustancia económica.' },
      { minPct: 25,  maxPct: 49,       message: 'un cuarto financiado. la visión y el dinero van alineándose.' },
      { minPct: 50,  maxPct: 74,       message: 'la mitad está ahí. los proyectos que llegan aquí suelen llegar al final.' },
      { minPct: 75,  maxPct: 99,       message: 'en la recta final. el proyecto ya huele a real.' },
      { minPct: 100, maxPct: Infinity, message: 'financiado al 100%. ahora el proyecto puede empezar en serio.' },
    ],
  },
  compromiso: {
    stages: [
      { minPct: 0,   maxPct: 0,        message: 'reconocer lo que debes ya es honestidad financiera.' },
      { minPct: 1,   maxPct: 24,       message: 'empezaste a reducir la deuda. cada pago es una decisión de libertad.' },
      { minPct: 25,  maxPct: 49,       message: 'un cuarto menos de lo que debías. el peso se siente diferente.' },
      { minPct: 50,  maxPct: 74,       message: 'a la mitad. lo que parecía enorme ya no lo es tanto.' },
      { minPct: 75,  maxPct: 99,       message: 'casi libre. los últimos pagos son los más satisfactorios.' },
      { minPct: 100, maxPct: Infinity, message: 'saldado. esa energía ahora puede ir a construir.' },
    ],
  },
  guardado: {
    stages: [
      { minPct: 0,   maxPct: 0,        message: 'guardar para lo que se repite es una de las formas más inteligentes de ahorrar.' },
      { minPct: 1,   maxPct: 24,       message: 'ya empezaste a anticipar ese gasto. eso cambia todo.' },
      { minPct: 25,  maxPct: 49,       message: 'un cuarto guardado. cuando llegue el gasto, ya no será una sorpresa.' },
      { minPct: 50,  maxPct: 74,       message: 'la mitad lista. este ciclo ya está bajo control.' },
      { minPct: 75,  maxPct: 99,       message: 'casi completo. en poco tiempo este ciclo se vuelve automático.' },
      { minPct: 100, maxPct: Infinity, message: 'listo para cuando llegue. así se ve la tranquilidad financiera.' },
    ],
  },
  fondo: {
    stages: [
      { minPct: 0,   maxPct: 0,        message: 'construir una reserva es cuidarte a ti misma en el tiempo.' },
      { minPct: 1,   maxPct: 24,       message: 'el fondo existe. es pequeño pero ya protege algo.' },
      { minPct: 25,  maxPct: 49,       message: 'un cuarto de la reserva formada. ya tienes un colchón real.' },
      { minPct: 50,  maxPct: 74,       message: 'mitad del fondo. ¿sabes cuántas emergencias podrías cubrir ahora?' },
      { minPct: 75,  maxPct: 99,       message: 'casi completo. este fondo es una de las mejores cosas que has hecho.' },
      { minPct: 100, maxPct: Infinity, message: 'reserva completa. la incertidumbre ya no manda aquí.' },
    ],
  },
}

export function getJourneyMessage(tipo, pct) {
  const journey = metaJourneys[tipo] || metaJourneys.meta
  const stage = journey.stages.find(s => pct >= s.minPct && pct <= s.maxPct)
  return stage ? stage.message : journey.stages[journey.stages.length - 1].message
}
